export const removeExtraWhitespace = (content: string): string => content
    .replace(/<p>(<br>)+?(&nbsp;)+<\/p>/g, "")
    .replace(/<p>&nbsp;<\/p>/g, "");